import defaults from './default.json';
import sideBar from './sideBar.json';
import formData from './formData.json';
import general from './general.json';
import table from './table.json';
import notify from './notify.json';
import step from './step.json';
import data from './data.json';
import tinyMedia from './tinyMedia.json'

export default {
    ...defaults,
    ...sideBar,
    ...formData,
    ...step,
    ...general,
    ...table,
    ...notify,
    ...data,
    ...tinyMedia
}